import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import layout_45global from "/app/middleware/layout.global.ts";
import superadmin_45global from "/app/middleware/superadmin.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  layout_45global,
  superadmin_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}